// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SliderAnimation-container-CoqCX {
	margin: 0 auto;
	padding-bottom: 24px;
	max-width: var(--max-content-width);
	padding: 0px 15px;
}

.SliderAnimation-homeCarsoual-FGqLu {
	position: absolute;
	width: 100%;
	height: 100vh;
	top: 0;
	overflow: hidden;
}

.SliderAnimation-homePosition-qyixY {
	position: relative;
	height: 100vh;
}

.SliderAnimation-bgHeight-luFqo {
	height: 100vh;
	width: calc(100% + 5px) !important;
	margin-left: -4px;
}

.SliderAnimation-searchCss-jJAqN {
	height: 56px;
	padding: 0 0 0 65px;
	font-size: 20px;
}

.SliderAnimation-searchbox-NIQHA {
	position: relative;
	margin: 45px 0 0 0;
}

.SliderAnimation-searchIcon-JQ9ZT {
	position: absolute;
	top: 17px;
	left: 16px;
}

.SliderAnimation-searchButton-ug6tF {
	position: absolute;
	top: 7px;
	right: 12px;
}

.SliderAnimation-searchButton-ug6tF button {
	color: var(--primary-btn-foreground);
	background-color: var(--primary-bg) !important;
	border-color: var(--primary-bg) !important;
	font-size: 17px;
	padding: 8px 13px;
}

.SliderAnimation-btn-danger-rnqus.SliderAnimation-active-ZmYYO.SliderAnimation-focus-vghdL,
.SliderAnimation-btn-danger-rnqus.SliderAnimation-active-ZmYYO:focus,
.SliderAnimation-btn-danger-rnqus.SliderAnimation-active-ZmYYO:hover,
.SliderAnimation-btn-danger-rnqus:active.SliderAnimation-focus-vghdL,
.SliderAnimation-btn-danger-rnqus:active:focus,
.SliderAnimation-btn-danger-rnqus:active:hover,
.SliderAnimation-open-bVz8z>.SliderAnimation-dropdown-toggle-c0Gs8.SliderAnimation-btn-danger-rnqus.SliderAnimation-focus-vghdL,
.SliderAnimation-open-bVz8z>.SliderAnimation-dropdown-toggle-c0Gs8.SliderAnimation-btn-danger-rnqus:focus,
.SliderAnimation-open-bVz8z>.SliderAnimation-dropdown-toggle-c0Gs8.SliderAnimation-btn-danger-rnqus:hover {
	color: var(--primary-btn-foreground);
	background-color: var(--primary-bg) !important;
	border-color: var(--primary-bg) !important;
}

.SliderAnimation-homeCarsoualMobile-qIi9H {
	display: none;
}

.SliderAnimation-downArrow-HusU9 {
	position: absolute;
	bottom: 10px;
	left: 0;
	right: 0;
	z-index: 0;
	text-align: center;
	-webkit-animation: SliderAnimation-bounce-ZrSKW 2s infinite;
	animation: SliderAnimation-bounce-ZrSKW 2s infinite;
	padding: 10px 0px;
}

@-webkit-keyframes SliderAnimation-bounce-ZrSKW {

	0%,
	20%,
	50%,
	80%,
	100% {
		-webkit-transform: translateY(0);
		        transform: translateY(0);
	}

	40% {
		-webkit-transform: translateY(-20px);
		        transform: translateY(-20px);
	}

	60% {
		-webkit-transform: translateY(-10px);
		        transform: translateY(-10px);
	}
}

@keyframes SliderAnimation-bounce-ZrSKW {

	0%,
	20%,
	50%,
	80%,
	100% {
		-webkit-transform: translateY(0);
		        transform: translateY(0);
	}

	40% {
		-webkit-transform: translateY(-20px);
		        transform: translateY(-20px);
	}

	60% {
		-webkit-transform: translateY(-10px);
		        transform: translateY(-10px);
	}
}

.SliderAnimation-downArrow-HusU9 img {
	display: inline-block;
}

.SliderAnimation-height100-vetXF {
	height: 100%;
}

.SliderAnimation-layoutOneFormContainer-hHUlw {
	position: relative;
	margin: 200px auto 0px;
}

.SliderAnimation-bannerCaptionText-KVQTx {
	color: var(--white-color);
	font-size: 42px;
	font-weight: bold;
	max-width: 1080px;
	max-width: var(--max-content-width);
	line-height: 50px;
	text-shadow: 0 6px 32px var(--primary-box-shadow) !important;
}

@media only screen and (min-width: 1600px) and (max-width: 2048px) {
	.SliderAnimation-downArrow-HusU9 {
		display: none;
	}

}

@media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
	.SliderAnimation-homePosition-qyixY {
		position: relative;
		height: 70vh;
	}

}

@media only screen and (min-width: 768px) and (max-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
	.SliderAnimation-homePosition-qyixY {
		position: relative;
		height: 70vh !important;
	}

	.SliderAnimation-bgHeight-luFqo {
		height: 70vh !important;
	}
}

@media only screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {
	.SliderAnimation-homePosition-qyixY {
		position: relative;
		min-height: 560px;
	}

	.SliderAnimation-downArrow-HusU9 {
		position: static;
		margin: -46px 0 0 0;
	}

}

@media only screen and (min-width: 375px) and (max-width: 992px) and (orientation: landscape) {
	.SliderAnimation-homePosition-qyixY {
		position: relative;
		min-height: 630px;
	}

	.SliderAnimation-downArrow-HusU9 {
		display: none;
	}


	.SliderAnimation-homeCarsoual-FGqLu {
		overflow: inherit;
		height: 100% !important;
	}
}

@media screen and (max-width:991px) {
	.SliderAnimation-bannerCaptionText-KVQTx {
		font-size: 32px;
		line-height: 32px;
	}
}

@media screen and (max-width: 640px) {
	.SliderAnimation-searchCss-jJAqN {
		font-size: 13px;
	}

}

@media screen and (max-width: 767px) {
	.SliderAnimation-layoutOneFormContainer-hHUlw {
		position: relative;
		margin: 80px auto 0px;
	}
}

@media (min-width: 768px) and (max-width: 992px) {
	.SliderAnimation-ContainerTab-ylKYs {
		width: 750px;
	}
}

@media (min-width: 768px) and (max-width: 1030px) {
	.SliderAnimation-container-CoqCX {
		padding: 0px 24px;
	}
}

@media only screen and (device-width : 375px) and (device-height : 812px) and (-webkit-device-pixel-ratio : 3) {
	.SliderAnimation-homeCarsoual-FGqLu {
		overflow: inherit;
		height: 100% !important;
	}

	.SliderAnimation-bgHeight-luFqo {
		margin-top: -1px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SliderAnimation/SliderAnimation.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,oBAAoB;CACpB,mCAAmC;CACnC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,MAAM;CACN,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAGA;CACC,aAAa;CACb,kCAAkC;CAClC,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,oCAAoC;CACpC,8CAA8C;CAC9C,0CAA0C;CAC1C,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;;;;;;;CASC,oCAAoC;CACpC,8CAA8C;CAC9C,0CAA0C;AAC3C;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,OAAO;CACP,QAAQ;CACR,UAAU;CACV,kBAAkB;CAElB,2DAAqC;CACrC,mDAA6B;CAC7B,iBAAiB;AAClB;;AAEA;;CAEC;;;;;EAKC,gCAAwB;UAAxB,wBAAwB;CACzB;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;AACD;;AAjBA;;CAEC;;;;;EAKC,gCAAwB;UAAxB,wBAAwB;CACzB;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;AACD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,mCAAmC;CACnC,iBAAiB;CACjB,4DAA4D;AAC7D;;AAEA;CACC;EACC,aAAa;CACd;;AAED;;AAEA;CACC;EACC,kBAAkB;EAClB,YAAY;CACb;;AAED;;AAEA;CACC;EACC,kBAAkB;EAClB,uBAAuB;CACxB;;CAEA;EACC,uBAAuB;CACxB;AACD;;AAGA;CACC;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;CACpB;;AAED;;AAEA;CACC;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;;;CAGA;EACC,iBAAiB;EACjB,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;;AAED;;AAEA;CACC;EACC,kBAAkB;EAClB,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,uBAAuB;CACxB;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".container {\n\tmargin: 0 auto;\n\tpadding-bottom: 24px;\n\tmax-width: var(--max-content-width);\n\tpadding: 0px 15px;\n}\n\n.homeCarsoual {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100vh;\n\ttop: 0;\n\toverflow: hidden;\n}\n\n.homePosition {\n\tposition: relative;\n\theight: 100vh;\n}\n\n\n.bgHeight {\n\theight: 100vh;\n\twidth: calc(100% + 5px) !important;\n\tmargin-left: -4px;\n}\n\n.searchCss {\n\theight: 56px;\n\tpadding: 0 0 0 65px;\n\tfont-size: 20px;\n}\n\n.searchbox {\n\tposition: relative;\n\tmargin: 45px 0 0 0;\n}\n\n.searchIcon {\n\tposition: absolute;\n\ttop: 17px;\n\tleft: 16px;\n}\n\n.searchButton {\n\tposition: absolute;\n\ttop: 7px;\n\tright: 12px;\n}\n\n.searchButton button {\n\tcolor: var(--primary-btn-foreground);\n\tbackground-color: var(--primary-bg) !important;\n\tborder-color: var(--primary-bg) !important;\n\tfont-size: 17px;\n\tpadding: 8px 13px;\n}\n\n.btn-danger.active.focus,\n.btn-danger.active:focus,\n.btn-danger.active:hover,\n.btn-danger:active.focus,\n.btn-danger:active:focus,\n.btn-danger:active:hover,\n.open>.dropdown-toggle.btn-danger.focus,\n.open>.dropdown-toggle.btn-danger:focus,\n.open>.dropdown-toggle.btn-danger:hover {\n\tcolor: var(--primary-btn-foreground);\n\tbackground-color: var(--primary-bg) !important;\n\tborder-color: var(--primary-bg) !important;\n}\n\n.homeCarsoualMobile {\n\tdisplay: none;\n}\n\n.downArrow {\n\tposition: absolute;\n\tbottom: 10px;\n\tleft: 0;\n\tright: 0;\n\tz-index: 0;\n\ttext-align: center;\n\t-moz-animation: bounce 2s infinite;\n\t-webkit-animation: bounce 2s infinite;\n\tanimation: bounce 2s infinite;\n\tpadding: 10px 0px;\n}\n\n@keyframes bounce {\n\n\t0%,\n\t20%,\n\t50%,\n\t80%,\n\t100% {\n\t\ttransform: translateY(0);\n\t}\n\n\t40% {\n\t\ttransform: translateY(-20px);\n\t}\n\n\t60% {\n\t\ttransform: translateY(-10px);\n\t}\n}\n\n.downArrow img {\n\tdisplay: inline-block;\n}\n\n.height100 {\n\theight: 100%;\n}\n\n.layoutOneFormContainer {\n\tposition: relative;\n\tmargin: 200px auto 0px;\n}\n\n.bannerCaptionText {\n\tcolor: var(--white-color);\n\tfont-size: 42px;\n\tfont-weight: bold;\n\tmax-width: 1080px;\n\tmax-width: var(--max-content-width);\n\tline-height: 50px;\n\ttext-shadow: 0 6px 32px var(--primary-box-shadow) !important;\n}\n\n@media only screen and (min-width: 1600px) and (max-width: 2048px) {\n\t.downArrow {\n\t\tdisplay: none;\n\t}\n\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n\t.homePosition {\n\t\tposition: relative;\n\t\theight: 70vh;\n\t}\n\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {\n\t.homePosition {\n\t\tposition: relative;\n\t\theight: 70vh !important;\n\t}\n\n\t.bgHeight {\n\t\theight: 70vh !important;\n\t}\n}\n\n\n@media only screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {\n\t.homePosition {\n\t\tposition: relative;\n\t\tmin-height: 560px;\n\t}\n\n\t.downArrow {\n\t\tposition: static;\n\t\tmargin: -46px 0 0 0;\n\t}\n\n}\n\n@media only screen and (min-width: 375px) and (max-width: 992px) and (orientation: landscape) {\n\t.homePosition {\n\t\tposition: relative;\n\t\tmin-height: 630px;\n\t}\n\n\t.downArrow {\n\t\tdisplay: none;\n\t}\n\n\n\t.homeCarsoual {\n\t\toverflow: inherit;\n\t\theight: 100% !important;\n\t}\n}\n\n@media screen and (max-width:991px) {\n\t.bannerCaptionText {\n\t\tfont-size: 32px;\n\t\tline-height: 32px;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.searchCss {\n\t\tfont-size: 13px;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.layoutOneFormContainer {\n\t\tposition: relative;\n\t\tmargin: 80px auto 0px;\n\t}\n}\n\n@media (min-width: 768px) and (max-width: 992px) {\n\t.ContainerTab {\n\t\twidth: 750px;\n\t}\n}\n\n@media (min-width: 768px) and (max-width: 1030px) {\n\t.container {\n\t\tpadding: 0px 24px;\n\t}\n}\n\n@media only screen and (device-width : 375px) and (device-height : 812px) and (-webkit-device-pixel-ratio : 3) {\n\t.homeCarsoual {\n\t\toverflow: inherit;\n\t\theight: 100% !important;\n\t}\n\n\t.bgHeight {\n\t\tmargin-top: -1px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SliderAnimation-container-CoqCX`,
	"homeCarsoual": `SliderAnimation-homeCarsoual-FGqLu`,
	"homePosition": `SliderAnimation-homePosition-qyixY`,
	"bgHeight": `SliderAnimation-bgHeight-luFqo`,
	"searchCss": `SliderAnimation-searchCss-jJAqN`,
	"searchbox": `SliderAnimation-searchbox-NIQHA`,
	"searchIcon": `SliderAnimation-searchIcon-JQ9ZT`,
	"searchButton": `SliderAnimation-searchButton-ug6tF`,
	"btn-danger": `SliderAnimation-btn-danger-rnqus`,
	"active": `SliderAnimation-active-ZmYYO`,
	"focus": `SliderAnimation-focus-vghdL`,
	"open": `SliderAnimation-open-bVz8z`,
	"dropdown-toggle": `SliderAnimation-dropdown-toggle-c0Gs8`,
	"homeCarsoualMobile": `SliderAnimation-homeCarsoualMobile-qIi9H`,
	"downArrow": `SliderAnimation-downArrow-HusU9`,
	"bounce": `SliderAnimation-bounce-ZrSKW`,
	"height100": `SliderAnimation-height100-vetXF`,
	"layoutOneFormContainer": `SliderAnimation-layoutOneFormContainer-hHUlw`,
	"bannerCaptionText": `SliderAnimation-bannerCaptionText-KVQTx`,
	"ContainerTab": `SliderAnimation-ContainerTab-ylKYs`
};
module.exports = ___CSS_LOADER_EXPORT___;
